import { Pagination, PaginationProps, Table } from "antd";
import { AnyObject } from "antd/es/_util/type";
import { ColumnsType } from "antd/es/table";
import { TableRowSelection } from "antd/es/table/interface";
import { ReactNode } from "react";
import NextIcon from "../../assets/icons/NextIcon";
import PrevIcon from "../../assets/icons/PrevIcon";

interface Props<DataListType> {
  loading: boolean;
  total: number;
  columns: ColumnsType<DataListType>;
  dataList: DataListType[];
  page: number;
  limit?: number;
  isSearch?: boolean;
  isPagination?: boolean;
  bordered?: boolean;
  handlePagination?: (paginationPage: number, paginationLimit: number) => void;
  rowSelection?: TableRowSelection<DataListType>;
  className?: string;
  underTheTableComponent?: ReactNode;
  underThePaginationComponent?: ReactNode;
  topOfTheTableComponent?: ReactNode;
  hideShadow?: boolean;
}

const CustomTable = <DataListType extends AnyObject>({
  loading,
  total,
  limit = 10,
  page,
  columns,
  dataList,
  isPagination = true,
  bordered = true,
  underTheTableComponent,
  handlePagination,
  rowSelection,
  className,
  underThePaginationComponent,
  topOfTheTableComponent,
  hideShadow,
}: Props<DataListType>) => {
  const itemRender: PaginationProps["itemRender"] = (
    _,
    type,
    originalElement
  ) => {
    if (type === "prev") {
      return (
        <span>
          <PrevIcon />
        </span>
      );
    }
    if (type === "next") {
      return (
        <span>
          <NextIcon />
        </span>
      );
    }
    return originalElement;
  };

  return (
    <div className="pt-5">
      <div
        className={`rounded-2xl ${
          !hideShadow ? "shadow shadow-gray-200" : ""
        } `}
      >
        {topOfTheTableComponent}
        <Table
          columns={columns}
          dataSource={dataList}
          loading={loading}
          pagination={false}
          rowSelection={rowSelection}
          className={`custom_edotco_table color_table custom-sidebar ${className}`}
          bordered={bordered}
        />
        {underTheTableComponent}
        {isPagination && dataList?.length ? (
          <div className="flex justify-center mt-6 relative custom_pagination">
            <Pagination
              onChange={handlePagination}
              current={page}
              showSizeChanger={false}
              total={total}
              defaultPageSize={limit}
              itemRender={itemRender}
            />
          </div>
        ) : null}
        {underThePaginationComponent}
      </div>
    </div>
  );
};

export default CustomTable;
